module.exports = "/_next/static/images/bbfc-logo--strapline-4b6aff2347393f6721613b0511945caa.svg";